import {
  Form,
  FormError,
  FieldError,
  Label,
  TextField,
  Submit,
} from '@redwoodjs/forms'
import { useAuth } from '@redwoodjs/auth'

const CalendarForm = React.forwardRef((props, ref) => {
  const { currentUser } = useAuth()

  const onSubmit = (data) => {
    data.userId = currentUser.id
    props.onSave(data, props?.calendar?.id)
  }

  return (
    <div className="rw-form-wrapper">
      <Form onSubmit={onSubmit} error={props.error}>
        <FormError
          error={props.error}
          wrapperClassName="rw-form-error-wrapper"
          titleClassName="rw-form-error-title"
          listClassName="rw-form-error-list"
        />

        <Label
          name="name"
          className="rw-label"
          errorClassName="rw-label rw-label-error"
        >
          Name
        </Label>
        <TextField
          name="name"
          defaultValue={props.calendar?.name}
          className="rw-input"
          errorClassName="rw-input rw-input-error"
          ref={ref}
          validation={{ required: true }}
        />
        <FieldError name="name" className="rw-field-error" />

        <div className="btn-group">
          <Submit disabled={props.loading} className="btn btn-blue">
            Save
          </Submit>
        </div>
      </Form>
    </div>
  )
})

export default CalendarForm
